export default __webpack_public_path__ + "static/media/card-image.427c7c0a.png";